import { render, staticRenderFns } from "./EditDocumentModal.vue?vue&type=template&id=4772cee5&scoped=true"
import script from "./EditDocumentModal.vue?vue&type=script&lang=js"
export * from "./EditDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./EditDocumentModal.vue?vue&type=style&index=0&id=4772cee5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4772cee5",
  null
  
)

export default component.exports